export default "__VITE_ASSET__dd57b1b2__"